module.exports = __webpack_public_path__ + "static/homepage-mobile-coast-7472e5321b37ad9e474f65bec047549e.jpg";